module.exports = __webpack_public_path__ + "static/media/Bagon_gaussian2.74cfd4ea.png";